import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ValuesPage = lazy(() => import('../pages/values/page'));
const BusinessPage = lazy(() => import('../pages/business/page'));
const NewsPage = lazy(() => import('../pages/news/page'));
const NewsDetailPage = lazy(() => import('../pages/news-detail/page'));
const StatsPage = lazy(() => import('../pages/stats/page'));
const WorksPage = lazy(() => import('../pages/works/page'));
const RecruitmentPage = lazy(() => import('../pages/recruitment/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const SecurityPage = lazy(() => import('../pages/security/page'));
const MarketingConsultingPage = lazy(() => import('../pages/marketing-consulting/page'));
const NewBusinessPage = lazy(() => import('../pages/new-business/page'));
const CRMConsultingPage = lazy(() => import('../pages/crm-consulting/page'));
const HRConsultingPage = lazy(() => import('../pages/hr-consulting/page'));
const DataMarketingPage = lazy(() => import('../pages/data-marketing/page'));
const AdMarketingPage = lazy(() => import('../pages/ad-marketing/page'));
const SNSMediaMarketingPage = lazy(() => import('../pages/sns-media-marketing/page'));
const WebCreationPage = lazy(() => import('../pages/web-creation/page'));
const VideoBrandingPage = lazy(() => import('../pages/video-branding/page'));
const SystemDevelopmentPage = lazy(() => import('../pages/system-development/page'));
const AIConsultingDevelopmentPage = lazy(() => import('../pages/ai-consulting-development/page'));
const NewsAdminPage = lazy(() => import('../pages/news-admin/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/values',
    element: <ValuesPage />,
  },
  {
    path: '/business',
    element: <BusinessPage />,
  },
  {
    path: '/news',
    element: <NewsPage />,
  },
  {
    path: '/news/:id',
    element: <NewsDetailPage />,
  },
  {
    path: '/stats',
    element: <StatsPage />,
  },
  {
    path: '/works',
    element: <WorksPage />,
  },
  {
    path: '/recruitment',
    element: <RecruitmentPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPage />,
  },
  {
    path: '/security',
    element: <SecurityPage />,
  },
  {
    path: '/marketing-consulting',
    element: <MarketingConsultingPage />,
  },
  {
    path: '/new-business',
    element: <NewBusinessPage />,
  },
  {
    path: '/crm-consulting',
    element: <CRMConsultingPage />,
  },
  {
    path: '/hr-consulting',
    element: <HRConsultingPage />,
  },
  {
    path: '/data-marketing',
    element: <DataMarketingPage />,
  },
  {
    path: '/ad-marketing',
    element: <AdMarketingPage />,
  },
  {
    path: '/sns-media-marketing',
    element: <SNSMediaMarketingPage />,
  },
  {
    path: '/web-creation',
    element: <WebCreationPage />,
  },
  {
    path: '/video-branding',
    element: <VideoBrandingPage />,
  },
  {
    path: '/system-development',
    element: <SystemDevelopmentPage />,
  },
  {
    path: '/ai-consulting-development',
    element: <AIConsultingDevelopmentPage />,
  },
  {
    path: '/news-admin',
    element: <NewsAdminPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
